import AbstractGlass from './AbstractGlass';

export default class GenericGlass extends AbstractGlass {}
